export const environment = {
    production: false,
    environment: 'dev',
    //may differs in different environment 
    apiUrl:'https://api.test01.rgcredsys.com/api/v1/'
}